import { UnsavedChangesProtection } from 'v5/patterns/forms/unsaved-changes/UnsavedChangesProtection';
import { Dialog, DialogContentHeadless } from 'v5/design-system/Dialog';
import { MountElementProps } from 'v5/messages/mount-element';
import { WithServices } from 'v5/platform/ts/services';
import { WithToastService } from 'v5/services/front/ToastService/ToastService';
import { WithUploadService } from 'v5/services/io/UploadService/UploadService';
import {
  EnterpriseWorkspaceDialogContent,
  EnterpriseWorkspaceFormData
} from './EnterpriseWorkspaceDialogContent';

export type CreateEnterpriseWorkspaceDialogProps = MountElementProps &
  WithServices<[WithUploadService, WithToastService]> & {
    onSubmit?: (data: EnterpriseWorkspaceFormData) => Promise<void> | void;
  };

export function CreateEnterpriseWorkspaceDialog({
  open,
  onOpenChange,
  close,
  onSubmit,
  services
}: CreateEnterpriseWorkspaceDialogProps) {
  return (
    <UnsavedChangesProtection
      open={open}
      onOpenChange={onOpenChange}
      beforeUnloadMessage="You have unsaved changes!"
    >
      {dialogProps => (
        <Dialog {...dialogProps}>
          <DialogContentHeadless className="max-w-150">
            <EnterpriseWorkspaceDialogContent
              open={dialogProps.open}
              services={services}
              onSubmit={async data => {
                await onSubmit?.(data);
                close();
              }}
            />
          </DialogContentHeadless>
        </Dialog>
      )}
    </UnsavedChangesProtection>
  );
}
